<template>
  <div uk-slider="finite: true">
    <ul class="uk-child-width-auto uk-child-width-1-4@s uk-grid-small uk-slider-items" uk-grid>
      <li v-for="item in sliderContent">
        <div class="uk-panel">
          <card :item="item"></card>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import card from './category-card'
  export default {
    name: 'category-slider',
    props: ['content', 'screenWidth'],
    components: {
      card
    },
    computed: {
      sliderContent() {
        if (this.screenWidth <= 1024) {
          return this.content.slice(0, 6)
        } else if (this.screenWidth <= 1366) {
          return this.content.slice(0, 5)
        } else {
          return this.content
        }
      }
    }
  }
</script>
<style scoped>
</style>
